import {useMemo} from "react";
import {useStage} from "@/components/konva/stage/ResponsiveStageHooks.ts";
import type {MapTransform} from "@/encounter/model/ViewPort.ts";
import type {Visibility} from "./VisibilityModel.ts";
import {useSoftFogWorker} from "./useSoftFogWorker.ts";
import {presentedFog} from "./PresentedFog.ts";

const FOG_CACHE_STEP_PIXELS = 192;
const FOG_CACHE_PADDING_PIXELS = 192;

export function useFogMask(visibility: Visibility, transform: MapTransform) {
    const {stageSize} = useStage();
    const fogAnchorX = Math.floor(transform.x / FOG_CACHE_STEP_PIXELS) * FOG_CACHE_STEP_PIXELS;
    const fogAnchorY = Math.floor(transform.y / FOG_CACHE_STEP_PIXELS) * FOG_CACHE_STEP_PIXELS;
    const fogWidth = stageSize.width + FOG_CACHE_PADDING_PIXELS * 2;
    const fogHeight = stageSize.height + FOG_CACHE_PADDING_PIXELS * 2;
    const scene = useMemo(() => visibility.enabled && stageSize.width > 0 && stageSize.height > 0
        ? {areas: visibility.areas, lights: visibility.lights, levelId: visibility.levelId, radiusMeters: visibility.radiusMeters,
            blockerKey: visibility.blockerKey, lighting: visibility.lighting,
            stageSize: {width: fogWidth, height: fogHeight}, transform: {
                x: fogAnchorX + FOG_CACHE_PADDING_PIXELS,
                y: fogAnchorY + FOG_CACHE_PADDING_PIXELS,
                scale: transform.scale,
            }}
        : undefined, [visibility.enabled, visibility.areas, visibility.lights, visibility.levelId, visibility.radiusMeters,
        visibility.blockerKey, visibility.lighting, stageSize.width, stageSize.height, fogWidth, fogHeight,
        fogAnchorX, fogAnchorY, transform.scale]);
    const {frame, unavailable} = useSoftFogWorker(scene);
    return {...presentedFog(visibility, frame, unavailable), unavailable};
}
